// extracted by mini-css-extract-plugin
export default {"container":"ugGIJNeYlXJfzw_2mEdL","title":"f_ulMZufXQ4QLKzREPhQ"};